import { CustomerModel } from '../models/customer.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Estate } from '../utils/enum.util';
import { Location } from '@angular/common'
import { PosturalService } from './postural.service';
import { BikeService2 } from './bike2.service';
//import { ServModel } from '../models/serv.model';
//import { ServService } from './serv.service';

@Injectable()
export class CustomerService {

    private parseApi    = {
        'adressName'          : {'adress': 'name'},
        'adressCountry'       : {'adress': 'country'},
        'adressCode'          : {'adress': 'code'},
        'adressCity'          : {'adress': 'city'},
        'sexeM'               : {'sexe': 'm'},
        'sexeF'               : {'sexe': 'f'},
        'interestedRun'       : {'interested': 'run'},
        'interestedVTT'       : {'interested': 'vtt'},
        'interestedService'   : {'interested': 'service'},
        'interestedAccessory' : {'interested': 'accessory'},
        'interestedCyclocross': {'interested': 'cyclocross'},
        'interestedGeneve'    : {'interested': 'geneve'},
        'interestedAubonne'   : {'interested': 'aubonne'},
    };
    private antiRebound = 300;
    private timestamp   = 0;
    private antiReboundField: string;

    public activities: any = {privateId: '', data: []};
    public resume: any     = {};

    tabActive: string = 'Résumé';

    constructor(public bikeService2: BikeService2, public apiService: ApiService, private router: Router, private location: Location, public posturalService: PosturalService) {

    }

    private convertFieldToApi(field: string, value: any): any {
        if (this.parseApi[field]) {
            let mainKey = Object.keys(this.parseApi[field]).toString();
            let key     = this.parseApi[field][mainKey];
            //TODO: A amélioer, car robin convertis les string en type
            return {[mainKey]: {[key]: value.toString()}};
        }
        return {[field]: value.toString()};
    }

    load(privateId: string, customer: CustomerModel) {
        this.apiService.get('client', 'privateId=' + privateId).subscribe(res=> {
            customer.privateId          = res.data._id;
            customer.publicId           = res.data.publicId;
            customer.adressCity         = res.data.adress.city;
            customer.adressCode         = res.data.adress.code;
            customer.adressCountry      = res.data.adress.country;
            customer.adressName         = res.data.adress.name;
            customer.firstName          = res.data.firstName;
            customer.lastName           = res.data.lastName;
            customer.mail               = res.data.mail;
            customer.height             = res.data.height;
            customer.weight             = res.data.weight;
            customer.crotch             = res.data.crotch;
            customer.percentageDiscount = res.data.percentageDiscount;

            if (res.data.phone.mobile.length == 13 && res.data.phone.mobile.substr(0, 4) == '0041')
                customer.phoneMobile = '0' + res.data.phone.mobile.substr(4, 2) + ' ' + res.data.phone.mobile.substr(6, 3) + ' ' + res.data.phone.mobile.substr(9, 2) + ' ' + res.data.phone.mobile.substr(11, 2);
            else
                customer.phoneMobile = res.data.phone.mobile;

            if (res.data.phone.fix.length == 13 && res.data.phone.fix.substr(0, 4) == '0041')
                customer.phoneFix = '0' + res.data.phone.fix.substr(4, 2) + ' ' + res.data.phone.fix.substr(6, 3) + ' ' + res.data.phone.fix.substr(9, 2) + ' ' + res.data.phone.fix.substr(11, 2);
            else
                customer.phoneFix = res.data.phone.fix;

            customer.sexeF                = res.data.sexe.f;
            customer.sexeM                = res.data.sexe.m;
            customer.interestedAccessory  = res.data.interested.accessory;
            customer.interestedRun        = res.data.interested.run;
            customer.interestedService    = res.data.interested.service;
            customer.interestedVTT        = res.data.interested.vtt;
            customer.interestedGeneve     = res.data.interested.geneve;
            customer.interestedAubonne    = res.data.interested.aubonne;
            customer.interestedCyclocross = res.data.interested.cyclocross;
            customer.comment              = res.data.comment;
            customer.archive              = res.data.archive;
            customer.looser               = res.data.looser;

            customer.state.firstName          = Estate.Save;
            customer.state.lastName           = Estate.Save;
            customer.state.phoneFix           = Estate.Save;
            customer.state.phoneMobile        = Estate.Save;
            customer.state.sexeM              = Estate.Save;
            customer.state.sexeF              = Estate.Save;
            customer.state.adressCountry      = Estate.Save;
            customer.state.adressCode         = Estate.Save;
            customer.state.adressCity         = Estate.Save;
            customer.state.adressName         = Estate.Save;
            customer.state.comment            = Estate.Save;
            customer.state.mail               = Estate.Save;
            customer.state.height             = Estate.Save;
            customer.state.weight             = Estate.Save;
            customer.state.crotch             = Estate.Save;
            customer.state.percentageDiscount = Estate.Save;
        }, (_err)=> {
            this.apiService.error(_err);
            this.router.navigate(['postit']);
        });
    }


    create(customer: CustomerModel) {
        customer.state.lastName    = Estate.Saving;
        customer.state.phoneFix    = Estate.Saving;
        customer.state.phoneMobile = Estate.Saving;

        const data: any = {
            'firstName': customer.firstName,
            'lastName' : customer.lastName,
            'phone'    : {
                'mobile': customer.phoneMobile.replace(/ /g, ''),
                'fix'   : customer.phoneFix.replace(/ /g, '')
            },
            'sexe'     : {
                'm': customer.sexeM.toString(),
                'f': customer.sexeF.toString()
            }
        };

        if (data.phone.mobile.length == 10 && data.phone.mobile.substr(0, 1) == '0') {
            data.phone.mobile = '0041' + data.phone.mobile.substr(1, 9);
        }

        if (data.phone.fix.length == 10 && data.phone.fix.substr(0, 1) == '0') {
            data.phone.fix = '0041' + data.phone.fix.substr(1, 9);
        }

        this.apiService.post('client', data).subscribe(res=> {
            this.location.replaceState('customer/' + res.data.privateId);
            customer.privateId                = res.data.privateId;
            customer.publicId                 = res.data.publicId;
            customer.state.firstName          = Estate.Save;
            customer.state.lastName           = Estate.Save;
            customer.state.phoneFix           = Estate.Save;
            customer.state.phoneMobile        = Estate.Save;
            customer.state.sexeM              = Estate.Save;
            customer.state.sexeF              = Estate.Save;
            customer.state.comment            = Estate.Save;
            customer.state.mail               = Estate.Save;
            customer.state.height             = Estate.Save;
            customer.state.weight             = Estate.Save;
            customer.state.crotch             = Estate.Save;
            customer.state.percentageDiscount = Estate.Save;
            customer.antiMultiPost            = false;
        }, (_err)=> {
            this.apiService.error(_err);
            customer.state.firstName   = Estate.Error;
            customer.state.lastName    = Estate.Error;
            customer.state.phoneFix    = Estate.Error;
            customer.state.phoneMobile = Estate.Error;
        });
    }

    update(customer: CustomerModel, field: string) {
        let data;

        customer.state[field] = Estate.Saving;

        //patch de merde du mobile
        if (field == 'phoneMobile' || field == 'phoneFix') {
            data = {
                phone: {
                    fix   : customer.phoneFix.replace(/ /g, ''),
                    mobile: customer.phoneMobile.replace(/ /g, '')
                }
            };
            if (data.phone.mobile.length == 10 && data.phone.mobile.substr(0, 1) == '0') {
                data.phone.mobile = '0041' + data.phone.mobile.substr(1, 9);
            }

            if (data.phone.fix.length == 10 && data.phone.fix.substr(0, 1) == '0') {
                data.phone.fix = '0041' + data.phone.fix.substr(1, 9);
            }
        } else {
            data = this.convertFieldToApi(field, customer[field]);
        }
        data['privateId'] = customer.privateId;


        //antiRebounce
        this.antiReboundField = field;
        this.timestamp        = new Date().getTime();
        setTimeout(()=> {
            if (this.antiReboundField != field || this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('client', data).subscribe((_res)=> {
                    customer.state[field] = Estate.Save;
                }, (_err)=> {
                    this.apiService.error(_err);
                    customer.state[field] = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    delete(customer: CustomerModel, action: string) {
        let data;

        //patch pour désarchiver
        if (action == 'delete')
            data = {privateId: customer.privateId, confirm: 'true'};
        if (action == 'archive')
            data = {privateId: customer.privateId, confirm: 'false'};
        if (action == 'unarchive')
            data = {privateId: customer.privateId, unarchive: 'true'};

        this.apiService.delete('client', data).subscribe((_res)=> {
            if (action == 'delete') {
                this.router.navigate(['/postit']);
            } else {
                customer.archive = !customer.archive;
            }
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    loadResume(privateId: string) {
        this.apiService.get('resume', 'clientPrivateId=' + privateId).subscribe(res=> {
            this.resume.privateId            = privateId;
            this.resume.depensed             = res.data.depensed;
            this.resume.created              = res.data.created;
            this.resume.nbrOrder             = res.data.nbrOrder;
            this.resume.nbrPassage           = res.data.nbrPassage;
            this.resume.nbrServices          = res.data.nbrService;
            this.resume.lastPassage          = res.data.lastPassage;
            this.resume.notRestituteServices = res.data.notRestituteService;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    getDocuments(privateId: string, data) {
        this.apiService.get('documents', 'clientPrivateId=' + privateId).subscribe(res=> {
            if (data.length > 0)
                data.length = 0;
            res.data.forEach((d)=> {
                data.push(d);
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    getPosturals(privateId: string) {
        this.posturalService.getAll(privateId);
    }

    getBikes(privateId: string) {
        this.bikeService2.getAll(privateId);
    }

    getActivities(privateId: string) {
        this.activities.data = [];
        this.apiService.get('activities', 'clientPrivateId=' + privateId).subscribe(res=> {
            this.activities.privateId = privateId;
            res.data.forEach((d)=> {
                this.activities.data.push(d);
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    addPassage(privateId: string, price: number) {
        if (!price)
            price = 0;
        this.apiService.post('passage', {'clientPrivateId': privateId, 'amount': price}).subscribe((_res)=> {
            this.loadResume(privateId);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/customer.service.ts